const locale = {
  locale: 'te_IN',
  today: 'ఈ రోజు',
  now: 'ఇప్పుడే',
  backToToday: 'ఈ రోజుకి వెళ్ళు',
  ok: 'సరే',
  clear: 'తొలగించు',
  week: 'వారం',
  month: 'నెల',
  year: 'సంవత్సరం',
  timeSelect: 'సమయాన్ని ఎంచుకోండి',
  dateSelect: 'తేదీని ఎంచుకోండి',
  weekSelect: 'వారం ఎంచుకోండి',
  monthSelect: 'నెల ఎంచుకోండి',
  yearSelect: 'సంవత్సరం ఎంచుకోండి',
  decadeSelect: 'దశాబ్దం ఎంచుకోండి',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,

  previousMonth: 'మునుపటి నెల (PageUp)',
  nextMonth: 'తదుపరి నెల (PageDown)',
  previousYear: 'మునుపటి సంవత్సరం (Control + left)',
  nextYear: 'తదుపరి సంవత్సరం (Control + right)',
  previousDecade: 'మునుపటి దశాబ్దం',
  nextDecade: 'తదుపరి దశాబ్దం',
  previousCentury: 'మునుపటి శతాబ్దం',
  nextCentury: 'తదుపరి శతాబ్దం',
}

export default locale
